import { ScoringOk, Insurance } from '../../../constants'

export interface ProductState {
  canFinishInIB: boolean
  canFinishOnline: boolean
  configuration: {
    amountFrom: number
    amountTo: number
    feeAmount: number
    instalmentAmount: number
    insuranceMonthlyPayment: number
    lastInstalmentAmount: number
    loanAmount: number
    primIntRate: number
    rpsn: number
    term: number
    termFrom: number
    termTo: number
    totalAmount: number
  }
  instalmentDay: number
  insuranceRequested: Insurance
  scoringResultCalculation: ScoringOk | null
}

export const initialState: ProductState = {
  canFinishInIB: true,
  canFinishOnline: true,
  configuration: {
    amountFrom: 0,
    amountTo: 0,
    feeAmount: 0,
    instalmentAmount: 0,
    insuranceMonthlyPayment: 0,
    lastInstalmentAmount: 0,
    loanAmount: 0,
    primIntRate: 0,
    rpsn: 0,
    term: 0,
    termFrom: 0,
    termTo: 0,
    totalAmount: 0,
  },
  instalmentDay: 20,
  insuranceRequested: Insurance.NotAvailable,
  scoringResultCalculation: null,
}
